<template>
    <!-- 编辑产品 -->
    <div class="">
      <v-dialog
        class="popbox"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >
        <v-form ref="form" :model="ruleForm" :rules="rules">
          <v-form-item  prop="product_name" >
            <template slot="label">
              <span class="required">*</span>
              <span>产品名称</span>
            </template>
            <v-input type="text" name="model" v-model="ruleForm.product_name"></v-input>
          </v-form-item>
          <v-form-item  prop="product_type" >
            <template slot="label">
              <span class="required">*</span>
              <span>产品类型</span>
            </template>
            <v-select id="product_type"  name="product_type" v-model="ruleForm.product_type" :options="productTypeOptins"></v-select>
          </v-form-item>
          <!-- <v-form-item prop="recursion">
            <template slot="label">
              <span class="required">*</span>
              <span>数据校验级别</span>
            </template>
              <v-radio class="options" v-model="ruleForm.check_level" name="checkLevel" :options="checkLevelOptions"></v-radio>
          </v-form-item> -->
          <v-form-item prop="recursion">
            <template slot="label">
              <span class="required">*</span>
              <span>认证方式</span>
            </template>
              <v-radio class="options" v-model="ruleForm.auth_style" name="authStyle" :options="authStyleOptions"></v-radio>
          </v-form-item>
          <v-form-item  prop="link_type" >
            <template slot="label">
              <span class="required">*</span>
              <span>连接类型</span>
            </template>
            <v-select id="link_type"  name="link_type" v-model="ruleForm.link_type" :options="linkOptins"></v-select>
          </v-form-item>
        <v-form-item  prop="sub_product_key" v-if="ruleForm.link_type == 'gateway'">
            <template slot="label">
              <span class="required">*</span>
              <span>子设备产品</span>
            </template>
            <v-select id="sub_product_key"  name="sub_product_key" v-model="ruleForm.sub_product_key" :options="linkproductOptins"></v-select>
          </v-form-item>
        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>

      </v-dialog>

    </div>

</template>

  <script>
import { copy } from '@/common/libs/utils';

  export default {
    components: {},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      },
      infoData:{
        type:Object,
        default: ()=>{}
      }
    },
    data() {
      return {
        dialogTitle: "编辑产品信息",
        rules: {
          product_name: copy([{
            type: "nameInput",
            args: [1,32]
          }]),
        },
        ruleForm:{
          product_name: '',
          product_type: '',
          appid: '',
          // check_level: '',
          auth_style: '',
          sub_product_key: '', //产品key
          link_type: '', //连接类型
        },
        productTypeOptins:[],
        checkLevelOptions:[
            {
              label: "免校验",
              value: 1
            },
            {
              label: "弱校验",
              value: 2
            },
            {
              label: "强校验",
              value: 3
            }
        ],
        authStyleOptions: [
            {
              label: "一机一密",
              value: 'machine'
            },
            {
              label: "一型一密",
              value: 'model'
            },
        ],
        linkOptins: [
            {
              label: "直连",
              value: 'direct_link'
            },
            {
              label: "网关",
              value: 'gateway'
            },
            {
              label: "网关子设备",
              value: 'sub_dev'
            },
        ],
        linkproductOptins: [],
        isShow:false,
        upTips:true,
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      open(){
        this.getproductType()
        this.getProductList()
        this.ruleForm = copy(this.infoData)
      },
      getproductType(){
        this.$getData("/td/td-iot-api/iot/product/types/v1", false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.productTypeOptins = res.data.map((item) =>{
              return {
                label: item.name,
                value: item.type
              }
            })
          }else {
            this.$message.error(res.msg);
          }
        });
      },
      getProductList(){
        const submitData = {
          app_id: sessionStorage.getItem("appid") || "",
        }
        this.$post("/td/td-iot-api/iot/common/product/list/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.linkproductOptins = res.data.map((item) =>{
              return {
                label: item.product_name,
                value: item.product_key
              }
            })
          }else {
            this.$message.error(res.msg);
          }
        });
      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
        let submitData = { ...this.ruleForm };
        this.$put("/td/td-iot-api/iot/product/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
      }
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
